import { Component, input } from '@angular/core';

@Component({
  selector: 'i-klankvoet-normal',
  imports: [],
  template: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 35 28" fill="none">
    <path d="m 0 0 h 12 v 12 h 19 v 12 h -31 z" fill="currentColor" style="opacity: 0.25" />
    <path d="m 0 0 h 12 v 12 h 19 v 12 h -31 z M 21 12 L 21 24" stroke="currentColor" stroke-width="2" />
    @if (showDubblezetter()) {
      <path d="M 3 21 L 3 15 L 9 15 L 9 21 Z M 10 21 L 10 15 L 16 15 L 16 21 Z" fill="currentColor" />
    }
  </svg> `,
  host: {
    class: 'grid place-items-center',
  },
})
export class IconKlankvoetNormal {
  showDubblezetter = input<boolean>(false);
}
